import React, { useEffect, useState, useRef } from "react";
import {FormValidator, useFormValidator, Inputs} from "coaz-ui";
import client from '../client';
import RoleAuthorities from "./RoleAuthorities";

const EditRole = ({params, submitRef, setLoading, setEnableSubmit}) => {
	const [role, setRole] = useState(null);
	const minWidth = 240;
	const [inputWidth, setInputWidth] = useState(minWidth);
	const { request,errorMessage } = client;
	const addButtonRef = useRef(null);

	const onChange = (e) => {
		const value = e.target.value;
		if (value === "") {
			setRole({ ...role, [e.target.name]: null });
		} else {
			setRole({ ...role, [e.target.name]: value });
		}
	};

	const submit = async (e) => {

		try {
            const response = await request("PUT", "roles", role);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
	};

	const [register, handleChange, handleSubmit, errors] =
		useFormValidator(submit);

	const inputs = [
		{
			label: "name",
			type: "text",
			name: "name",
			value: role && role.name ? role.name : "",
			placeholder: "Enter name...",
			onChange: (e) => {
				handleChange(e, onChange);
			},
			register: register,
			checks: ["empty"],
			errors: errors,
		}
	];

	useEffect(() => {
		if (handleSubmit) {
			submitRef.current = { submit: handleSubmit };
			setEnableSubmit(true);
		} else {
			submitRef.current = null;
			setEnableSubmit(false);
		}

		return () => {
			submitRef.current = null;
		};
	}, [handleSubmit]);

	useEffect(() => {
		(async () => {
			if(!params || !params.id) return;
			setLoading && setLoading(true);

			try {
				const response = await request("GET", `roles/${params.id}`);
				if (response && response.ref) {
					setRole(response);
				} 
			} catch (error) {
				console.log(error);
			} finally {
				setLoading && setLoading(false);
			}
		})();
	}, []);

	return (
		<FormValidator>
			<div className="flex flex-col w-full h-auto">
				<div className="flex flex-col w-full h-auto space-y-4 shrink-0">
					<Inputs
						inputs={inputs}
						minWidth={minWidth}
						paddingX={0}
						spaceX={32}
						id="add_usertype"
						setCalcWidth={setInputWidth}
					/>
					<RoleAuthorities role={role} setRole={setRole} />
				</div>
			</div>
		</FormValidator>
	);
};

export default EditRole;
